module.exports = __webpack_public_path__ + "d62c2dc85f3b2b050db28bc4cca62ea4.png";